document.addEventListener('DOMContentLoaded', function() {
  try {
    // Grab all gallery links up front
    const links = document.querySelectorAll('.tabs-gallery a');

    // If SimpleLightbox isn't loaded…
    if (typeof SimpleLightbox !== 'function') {
      if (links.length) {
        console.warn('SimpleLightbox not found; disabling gallery links.');
        links.forEach(link => {
          link.setAttribute('href', '#');
          link.addEventListener('click', e => e.preventDefault());
        });
      }
      return;
    }

    // If there are no gallery links, nothing to do
    if (!links.length) {
      console.info('No .tabs-gallery links found. Skipping lightbox init.');
      return;
    }

    // Finally, initialize SimpleLightbox
    new SimpleLightbox({ elements: '.tabs-gallery a' });

  } catch (err) {
    console.error('Error setting up gallery/lightbox:', err);
  }
});
